// KKK - collectionajax.js

jQuery(document).ready(function() {
  $(".availablitybox").hide();
  console.log("===>");
    setTimeout(function() {    
     var data = [];      
jQuery(".variantsku").each(function() {
  var sku = jQuery(this).data('sku');
  var webumdisplay = jQuery(this).data('webumdisplay');
  var webumqty = jQuery(this).data('webumqty');
  data.push({"item": sku,"webumdisplay":webumdisplay,"webumqty":webumqty});
  
});  
  
var jsonData = JSON.stringify(data);      
var xhr = new XMLHttpRequest();

xhr.addEventListener("readystatechange", function() {
    if (this.readyState === 4) {
        if (this.status === 200) { // Check if the request was successful
            var priceData = this.responseText;
          console.log(priceData);
          var priceData = JSON.parse(this.responseText);
            priceData.forEach(function(item) {
              console.log(item);
              var sku = item[0];
              var avaliablity = item[1];
              $(".availability"+sku).val(item[3]);
              $(".uncsku" + sku + " .quantity__input").attr("max",item[1]);
              $(".availablity_bag" + sku + " .comingsoon").html("<span>Coming Soon: </span>"+item[2]);
              $(".availablity_bag" + sku + " .instock").html("<span>In Stock: </span>"+item[3]);
              if(avaliablity <=0)
              {
                jQuery(".sku" + sku + " .add-to-cart__submit").attr('disabled', true);
                jQuery(".sku" + sku + " button").attr('disabled', true);
              }                
              else
              {
                jQuery(".sku" + sku + " .add-to-cart__submit").attr('disabled', false);
                jQuery(".sku" + sku + " button").attr('disabled', false);
              }
            });
        } else {
            console.error("Error:", this.responseText);
        }
    }
});    

xhr.open("POST", "https://sandybrown-viper-258024.hostingersite.com/HDI/getAvailability.php");
xhr.setRequestHeader("Content-Type", "application/json");    
xhr.send(jsonData);

  }, 1200);
});